import React from 'react';
import { SimpleInput } from '../../index';
import { useField, useForm } from '../../../custom-hooks';
import { isValidLength } from '../../../utils/validators';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/react-hooks';

import {ACCOMMODATION_BOOKING_NOTES, ACTIVITY_BOOKING_NOTES} from '../../../graphql/mutations/booking';
import { useSnackbar } from 'notistack';

const NotesForm = ({
  id,
  defaultValue = '',
  onCancel,
  onConfirm,
  refetchParams,
  isActivity,
  accommodationId
}) => {
  const [t] = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [updateAccommodationBookingNotes, { loading }] = useMutation(
    ACCOMMODATION_BOOKING_NOTES,
    {
      refetchQueries: [refetchParams]
    }
  );
  const [
    updateActivityBookingNotes,
    { loading: loadingActivity }
  ] = useMutation(ACTIVITY_BOOKING_NOTES, {
    refetchQueries: [refetchParams]
  });

  const notesForm = useForm({
    onSubmit: (formData, formValid) => {
      if (!formValid) return;

      (isActivity
        ? updateActivityBookingNotes({
            variables: {
              id,
              activityBookingNotes: { activityNotes: formData.note }
            }
          })
        : updateAccommodationBookingNotes({
          variables: {
            id,
            accommodationBookingNotes: { 
              accommodationId,
              bookingNotes: formData.note,
              
            },
          },
          })
      )
        .then(() => {
          onCancel && onCancel();
          onConfirm(formData.note);
        })
        .catch(() => {
          enqueueSnackbar(t('Notes were not updated. Try again.'), {
            variant: 'warning'
          });
        });
    }
  });

  const noteField = useField('note', notesForm, {
    defaultValue,
    validations: [
      formData =>
        isValidLength(formData.note, 400, 'Max note length is 400 symbols')
    ]
  });

  return (
    <form onSubmit={notesForm.handleSubmit} style={{ width: '100%' }}>
      <SimpleInput
        placeholder={t('Notes')}
        value={noteField.value}
        onChange={noteField.onChange}
        errors={noteField.errors}
        errorText={noteField.errors[0]}
        style={{ width: '100%' }}
        fullWidth
        multiline
        rows={6}
        disabled={loading || loadingActivity}
      />

      <div style={{ marginTop: '10px', display: 'flex' }}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={
            noteField.value === defaultValue ||
            (noteField.errors && noteField.errors.length) ||
            loading ||
            loadingActivity
          }
          style={{ marginRight: '10px' }}
        >
          {t('Save')}
        </Button>

        {!!defaultValue && (
          <Button variant="outlined" color="secondary" onClick={onCancel}>
            {t('Cancel')}
          </Button>
        )}
      </div>
    </form>
  );
};

export default NotesForm;
